import { useMutation } from '@tanstack/react-query';
import { useDebounce } from '@uidotdev/usehooks';
import {
  AutoComplete,
  Col,
  Flex,
  Row,
  Space,
  Spin,
  Tag,
  Typography,
} from 'antd';
import { CustomerApis } from 'apis/CustomerApis';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import {
  QUERY_SEARCH_NOT_CUSTOMER_SALELINE,
  QUERY_SEARCH_NOT_CUSTOMER_TEAMSALE,
  VARIABLE_SEARCH_NOT_CUSTOM_SALELINE,
  VARIABLE_SEARCH_NOT_CUSTOM_TEAMSALE,
} from 'apis/GraphQL/Queries/saleLineQuery';
import { QUERY_SEARCH_NOT_CUSTOMER_SALEPLAN } from 'apis/GraphQL/Queries/salePlan';
import { SALE_PLAN_VARIABLE } from 'apis/GraphQL/Variables/salePlan';
import { PlusIcon } from 'assets/svg';
import { Button } from 'components';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import { Dispatch, useCallback, useEffect, useState } from 'react';
import { toastError } from 'utils/constants/functions';
import CustomerCard from './CustomerCard';
import { useAmlCheck } from 'hooks/useAmlCheck';

interface Iprops {
  searchId: any;
  newCustomer: any[];
  setData: Dispatch<any>;
  setOpenMap: Dispatch<boolean>;
  setLocation: Dispatch<any>;
  setNewCustomer: (data: any) => void;
  type: any;
  search: {
    value: string;
    setValue: React.Dispatch<string>;
  };
  customer: {
    customer: any;
    setCustomer: React.Dispatch<any>;
  };
}

const getAddress = ({
  address,
  cityName,
  districtName,
  wardName,
}: {
  address: string | null;
  wardName: string | null;
  districtName: string | null;
  cityName: string | null;
}) => {
  const res = [address, wardName, districtName, cityName]
    .filter((item) => item)
    .join(', ');

  if (!res) return 'Chưa cập nhật';

  return `Địa chỉ: ${res}`;
};

export default function CustomerList(props: Iprops) {
  const {
    searchId,
    newCustomer,
    setNewCustomer,
    setData,
    setOpenMap,
    setLocation,
    type = true,
  } = props;
  const { customer: item, setCustomer: setItem } = props.customer;
  const { value: inputValue, setValue: setInputValue } = props.search;
  const [users, setUsers] = useState<any[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const inputValueDebounce = useDebounce(inputValue, 500);
  const { checkAndProceed, amlModalContext } = useAmlCheck();

  const mutationSearch = useMutation({
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    // onSuccess: (res: any, variables: any) => {
    //   let data = {};

    //   // console.log('res', res.data?.getCustomerNotInRoute?.[0]);
    //   if (variables.type == 'SaleLine')
    //     data = res.data?.getCustomerNotInRoute?.[0] || {};
    //   // setItem(res.data?.getCustomerNotInRoute?.[0] || {});
    //   if (variables.type == 'TeamSale')
    //     data = res.data?.getCustomerNotInTeamSale?.[0] || {};
    //   // setItem(res.data?.getCustomerNotInTeamSale?.[0] || {});
    //   if (variables.type == 'SaleLineTeamSale')
    //     data = res.data?.getCustomerNotInTeamOrRoute?.[0] || {};
    //   // setItem(res.data?.getCustomerNotInTeamOrRoute?.[0] || {});
    //   if (variables.type == true)
    //     data = res.data?.getCustomerNotInPlanning?.[0] || {};
    //   // setItem(res.data?.getCustomerNotInPlanning?.[0] || {});

    //   if (Object.keys(data).length == 0)
    //     toastError('Không tìm thấy khách hàng');

    //   setItem(data);
    // },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutateAsync: checkCustomerExist } = useMutation({
    mutationFn: (searchValue: string) => {
      if (type == 'SaleLine')
        return CustomerApis.searchCustomerInRoute({
          routeId: searchId,
          searchValue,
        });

      if (type == 'TeamSale')
        return CustomerApis.searchCustomerInTeamSale({
          searchValue,
          teamSalesId: searchId,
        });

      return CustomerApis.searchCustomerInSalePlan({
        salesPlanningId: searchId,
        searchValue,
      });
    },
  });

  function AddCustomer(newCustomer: any) {
    checkAndProceed(
      {
        ...newCustomer,
        id: newCustomer.customerId || newCustomer.id,
      },
      () => {
        setNewCustomer((prev: any[]) => {
          if (
            prev.findIndex((item: any) =>
              [newCustomer.id, newCustomer.customerId].includes(item.id),
            ) === -1
          )
            return [
              ...prev,
              {
                ...newCustomer,
                id: newCustomer.customerId || newCustomer.id,
              },
            ];
          return prev;
        });
        setItem(undefined);
        setInputValue('');
        setUsers([]);
      },
    );
  }

  // const handleEnter = async () => {
  //   const formattedInputVal = inputValue.trim();

  //   if (!formattedInputVal) {
  //     toastError('Vui lòng nhập mã DMS/SAP/MST');
  //     setItem({});

  //     return;
  //   }

  //   const queries = [];

  //   if (type == 'SaleLine') {
  //     queries.push(
  //       mutationSearch.mutateAsync({
  //         query: QUERY_SEARCH_NOT_CUSTOMER_SALELINE,
  //         variables: VARIABLE_SEARCH_NOT_CUSTOM_SALELINE({
  //           custId: formattedInputVal,
  //           routeId: searchId,
  //         }),
  //         type: 'SaleLine',
  //       }),
  //     );
  //   } else if (type == 'TeamSale') {
  //     queries.push(
  //       mutationSearch.mutateAsync({
  //         query: QUERY_SEARCH_NOT_CUSTOMER_TEAMSALE,
  //         variables: VARIABLE_SEARCH_NOT_CUSTOM_TEAMSALE({
  //           custId: formattedInputVal,
  //           teamId: searchId,
  //         }),
  //         type: 'TeamSale',
  //       }),
  //     );
  //   } else {
  //     queries.push(
  //       mutationSearch.mutateAsync({
  //         query: QUERY_SEARCH_NOT_CUSTOMER_SALEPLAN,
  //         variables: SALE_PLAN_VARIABLE.searchNotCustomSalePlan({
  //           custId: formattedInputVal,
  //           salesPlanningId: searchId,
  //         }),
  //         type: true,
  //       }),
  //     );
  //   }

  //   // queries.push(checkCustomerExist(formattedInputVal));

  //   const [res] = await Promise.all(queries);

  //   // const existCustomer =
  //   //   exist?.data?.getRouteDetail?.items[0] ||
  //   //   exist?.data?.getTeamSalesCust?.items[0] ||
  //   //   exist?.data?.getSalesPlanningCust?.items[0];

  //   // if (existCustomer)
  //   //   return toastError('Khách hàng đã được thêm vào danh sách');

  //   let data = {};

  //   if (type == 'SaleLine')
  //     data = res.data?.getCustomerNotInRoute?.items?.[0] || {};
  //   else if (type == 'TeamSale')
  //     data = res.data?.getCustomerNotInTeamSale?.items?.[0] || {};
  //   else data = res.data?.getCustomerNotInPlanning?.items?.[0] || {};
  //   if (Object.keys(data).length == 0) toastError('Không tìm thấy khách hàng');

  //   setItem(data);
  // };

  // function handleSearch(_: any, __: any, { source }: any) {
  //   if (source === 'clear') return;
  //   handleEnter();
  // }

  const handleSearchUsers = useCallback(
    async (value: string) => {
      setLoadingUsers(true);
      const formattedInputVal = value.trim();
      const queries = [];

      if (type == 'SaleLine') {
        queries.push(
          mutationSearch.mutateAsync({
            query: QUERY_SEARCH_NOT_CUSTOMER_SALELINE,
            variables: VARIABLE_SEARCH_NOT_CUSTOM_SALELINE({
              custId: formattedInputVal,
              routeId: searchId,
            }),
            type: 'SaleLine',
          }),
        );
      } else if (type == 'TeamSale') {
        queries.push(
          mutationSearch.mutateAsync({
            query: QUERY_SEARCH_NOT_CUSTOMER_TEAMSALE,
            variables: VARIABLE_SEARCH_NOT_CUSTOM_TEAMSALE({
              custId: formattedInputVal,
              teamId: searchId,
            }),
            type: 'TeamSale',
          }),
        );
      } else {
        queries.push(
          mutationSearch.mutateAsync({
            query: QUERY_SEARCH_NOT_CUSTOMER_SALEPLAN,
            variables: SALE_PLAN_VARIABLE.searchNotCustomSalePlan({
              custId: formattedInputVal,
              salesPlanningId: searchId,
            }),
            type: true,
          }),
        );
      }

      try {
        const [data] = await Promise.all(queries);

        const customers =
          data?.data?.getCustomerNotInRoute?.items ||
          data?.data?.getCustomerNotInTeamSale?.items ||
          data?.data?.getCustomerNotInPlanning?.items ||
          [];

        const users = customers.map((item: any) => {
          let prefix = item.sapCustomerId ?? item.customerId;

          if ((item.sapCustomerId || '').includes(formattedInputVal))
            prefix = item.sapCustomerId;
          else if ((item.customerId || '').includes(formattedInputVal))
            prefix = item.customerId;
          else if ((item.cccd || '').includes(formattedInputVal))
            prefix = item.cccd;
          else if ((item.taxId || '').includes(formattedInputVal))
            prefix = item.taxId;

          return {
            ...item,
            value: prefix,
            label: prefix + (item.storeName ? ' - ' + item.storeName : ''),
          };
        });

        setUsers(users);
      } catch (error) {
        //
      } finally {
        setLoadingUsers(false);
      }
    },
    [searchId, type],
  );

  const handleSelectUser = (value: string) => {
    const user = users.find((item) => item.value === value);

    if (!user) return;

    setItem(user);
  };

  const handleClearUser = () => {
    setItem(undefined);
    setInputValue('');
    setUsers([]);
  };

  const handleChangeUser = (value: string) => {
    setInputValue(value);

    if (!value) setUsers([]);
  };

  useEffect(() => {
    if (inputValueDebounce) handleSearchUsers(inputValueDebounce);
    else setUsers([]);
  }, [handleSearchUsers, inputValueDebounce]);

  return (
    <>
      <Flex gap={10} vertical>
        <Space direction="vertical" size={5}>
          <Typography.Text className="mb-0">Khách hàng</Typography.Text>
          {/* <Input.Search
            allowClear
            value={inputValue}
            placeholder="Tìm mã DMS/SAP/MST"
            onSearch={handleSearch}
            onPressEnter={handleEnter}
            onChange={(e) => setInputValue(e.target.value)}
          /> */}
          <AutoComplete
            // disabled={!plantId && isAdd}
            value={inputValue}
            notFoundContent={
              loadingUsers ? (
                <Flex justify="center">
                  <Spin size="small" />
                </Flex>
              ) : null
            }
            allowClear
            size="middle"
            className="w-full rounded-xl"
            options={users}
            // onSearch={handleSearchUsers}
            onClear={handleClearUser}
            onSelect={handleSelectUser}
            onChange={handleChangeUser}
            placeholder="Nhập mã/tên khách hàng"
          />
        </Space>
        <Flex
          gap={8}
          align={'center'}
          justify={'start'}
          className="p-2 bg-[#E4F3FF] rounded-[16px] flex-auto"
        >
          {item?.customerId && (
            <>
              <Button
                customClass="bg-white w-10 h-10"
                title={<PlusIcon />}
                handleOnclick={() => AddCustomer(item)}
              />
              <Col span={22}>
                <Row style={{ width: '100%' }} gutter={[8, 8]} align={'middle'}>
                  <Col className="text-[16px] font-bold text-[#003056] break-all">
                    {item?.storeName || '-'}
                  </Col>
                  {item?.rankName && (
                    <Col>
                      <Tag
                        color="blue"
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        <span style={{ color: '#003056' }}>
                          {item?.rankName}
                        </span>
                      </Tag>
                    </Col>
                  )}
                </Row>

                <div className="">
                  <span className="text-base text-[#003056]">
                    {getAddress({
                      address: item?.address,
                      cityName: item?.cityName,
                      districtName: item?.districtName,
                      wardName: item?.wardName,
                    })}
                  </span>
                  <button
                    className="ml-2"
                    onClick={() => {
                      if (!item?.latitude && !item?.longitude) {
                        toastError('Khách hàng chưa có vị trí');
                        return;
                      }
                      setOpenMap(true);
                      setLocation(item);
                    }}
                  >
                    <span
                      style={{
                        color: '#003056',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                      }}
                    >
                      Xem bản đồ
                    </span>
                  </button>
                </div>

                {type !== 'TeamSale' && !item?.isInArea && (
                  <Row
                    style={{ width: '100%' }}
                    gutter={[8, 8]}
                    align={'middle'}
                  >
                    <Col
                      style={{
                        fontSize: '16px',
                        color: '#DC362E',
                      }}
                    >
                      Lưu ý: Địa chỉ khách hàng không trong khu vực tuyến
                    </Col>
                  </Row>
                )}
              </Col>
            </>
          )}
        </Flex>
      </Flex>
      <div className="text-[16px] font-bold border-b my-[10px] pb-[8px]">
        Mới
      </div>
      {(newCustomer || []).length == 0 ? (
        'Chưa có khách hàng'
      ) : (
        <CustomerCard
          setData={setData}
          setOpenMap={setOpenMap}
          setLocation={setLocation}
          data={newCustomer}
          type="tab1"
          // setData={setData}
          handleAddCusomer={setNewCustomer}
        />
      )}

      {type == true && (
        <>
          <div className="text-[16px] font-bold border-b my-[10px] pb-[8px]">
            Khách trong tuyến
          </div>
          <CustomerCard
            setData={setData}
            setOpenMap={setOpenMap}
            setLocation={setLocation}
            data={[]}
            handleAddCusomer={() => {
              console.log('test');
            }}
          />
        </>
      )}
      {amlModalContext}
    </>
  );
}
